import Vue from 'vue'
// import axios from 'axios'
import axios from '@/wrappers/axios.js'
// import store from '../../store';

const TicketService = {

    ticketList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/tickets${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    createTicket(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/tickets`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getTicket(id, params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/tickets/${id}${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    updateTicket(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/tickets/${id}`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getParentTicketList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/tickets/parent-tickets${params}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },


    getRelatedTicketList(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/tickets/${id}/related`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    uploadFiles(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/tickets/${id}/upload-files?includes=files`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    deleteFile(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/tickets/${id}/delete-file`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    exportTickets(data) {
        return new Promise(async (resolve,reject) => {
            axios
                .post(`/tickets/export`, data).then((response)=>{
                    resolve(response)
                })
                .catch(e => reject(e));
        })
    },
    sort(data) {
        return new Promise(async (resolve,reject) => {
            axios
                .post(`/tickets/sort`, data).then((response)=>{
                    resolve(response)
                })
                .catch(e => reject(e));
        })
    },

}

Vue.$ticketService = TicketService

export default TicketService